module.exports = __webpack_public_path__ + "static/Kreo_Battleship_Mini_Movie-a69124209ef4c3090fcd5570e3f99a2d.mp4";